import { useDispatch } from "react-redux";

import useHandbookLvl from "pages/HandBook/utils/useHandbookLvl";

import { handBookActions, HANDBOOK_TEMPLATE_LVL } from "../../model/slice";
import {
  applyEditingHandbookTemplates,
  cancelEditingHandbookTemplates,
  cloneCheckedHandbookSections,
  localDeleteCheckedHandbookTemplates,
} from "../../model/thunks";
import HandBookEditButtonBase from "./HandBookEditButtonBase";
import { useTypedSelector } from "app/store/typedUseSelector";
import { useMemo } from "react";

const HandBookEditTemplatesButton = () => {
  const dispatch = useDispatch();
  const {handbookLvl, templateId, sectionId} = useHandbookLvl();
  const templateEditings = useTypedSelector((state) => state.handBookReducer.templateEditings);
  const editings = templateEditings[handbookLvl];
  const isEditing = templateEditings.isEditing;

  const enableEditing = () => {
    dispatch(handBookActions.setEditingTemplates(true));
  };
  const cancelEditing = () => {
    dispatch(cancelEditingHandbookTemplates());
  };
  const applyEditing = () => {
    dispatch(applyEditingHandbookTemplates());
  };
  const deleteChecked = () => {
    dispatch(localDeleteCheckedHandbookTemplates());
  };
  
  const cloneChecked = useMemo(() => {
    if (handbookLvl === HANDBOOK_TEMPLATE_LVL.SECTIONS) {
      return () => {
        dispatch(cloneCheckedHandbookSections({ templateId, sectionId }));
      };
    }
  }, [handbookLvl, templateId, sectionId]);


  return (
    <HandBookEditButtonBase
      editings={editings}
      isEditing={isEditing}
      enableEditing={enableEditing}
      cancelEditing={cancelEditing}
      applyEditing={applyEditing}
      deleteChecked={deleteChecked}
      cloneChecked={cloneChecked}
      modalTitle="Редактирование шаблонов"
    />
  );
};

export default HandBookEditTemplatesButton;
